import React from 'react';
import Badge from '@spark/ui-components/components/Badge';
import { Button } from '@spark/ui-components/components/Button';
import styled from 'styled-components'; // Componentes estilizados para clientes

const StatusBadge = styled(Badge)`
  font-size: 0.75rem;
  padding: 4px 8px;
`;
const ActionButton = styled(Button)`
  margin-right: 4px;
  &:last-child {
    margin-right: 0;
  }
`;
/**
 * Colunas da tabela de clientes usando TanStack Table
 * @returns {Array} Array de colunas configuradas
 */

export const getClientesColumns = () => [{
  id: 'nome',
  accessorKey: 'nome',
  header: 'Nome',
  size: 200,
  cell: ({
    row
  }) => <div style={{
    fontWeight: 'bold'
  }}>
        {row.original.nome}
      </div>
}, {
  id: 'cnpj',
  accessorKey: 'cnpj',
  header: 'CNPJ',
  size: 180,
  cell: ({
    row
  }) => <div style={{
    fontFamily: 'monospace',
    fontSize: '0.9rem'
  }}>
        {row.original.cnpj}
      </div>
}, {
  id: 'telefone',
  accessorKey: 'telefone',
  header: 'Telefone',
  size: 150
}, {
  id: 'email',
  accessorKey: 'email',
  header: 'Email',
  size: 200
}, {
  id: 'observacoes',
  accessorKey: 'observacoes',
  header: 'Observações',
  size: 200,
  cell: ({
    row
  }) => <div style={{
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }}>
        {row.original.observacoes}
      </div>
}, {
  id: 'dataCriacao',
  accessorKey: 'dataCriacao',
  header: 'Data Criação',
  size: 120
}, {
  id: 'dataModificacao',
  accessorKey: 'dataModificacao',
  header: 'Última Modificação',
  size: 120
}];
